module.exports = __webpack_public_path__ + "static/media/Brightness.a7a9e859.svg";